import { Redirect, Route, RouteProps, Switch } from "react-router-dom";
import { useLangContext } from "@layouts/home/LangContext";
import { SessionState } from "maven-lib/dist/states/reducers/session";
import { AccessTokenAuth } from "./AccessTokenAuth";
import { useRoute, useStringParam } from "@maven-surface/hooks";

interface AccessTokenAuthRouteProps extends RouteProps {
  session: SessionState | null;
}
export function AccessTokenAuthRoute(props: AccessTokenAuthRouteProps) {
  useLangContext();
  const { render, session, component: Component, ...rest } = props;
  const { query } = useRoute();
  const accessToken = useStringParam(query?.t, true);

  return (
    <Switch>
      <Route exact={true} path="/token-auth" component={AccessTokenAuth} />
      {!accessToken ? (
        <Route render={(props) => render && render(props)} />
      ) : (
        <Redirect to={{ pathname: "/token-auth", search: rest.location?.search, state: { targetPath: rest.location?.pathname } }} />
      )}
      <Redirect from="*" to="/404?at" />
    </Switch>
  );
}
